import {onActivated, onDeactivated, ref} from "vue";

export default function useActivated() {
    let isActivated = ref(true);
    onActivated(() => isActivated.value = true);
    onDeactivated(() => isActivated.value = false);
    return isActivated;
}